export enum STEPS {
  STEP_ONE = 'STEP ONE',
  STEP_TWO = 'STEP TWO',
  STEP_TWO_B = 'STEP TWO.B',
  STEP_THREE = 'STEP THREE',
  STEP_FOUR = 'STEP FOUR',
  STEP_FIVE = 'STEP FIVE',
  STEP_SIX = 'STEP SIX',
  FINAL = 'FINAL',
}


export interface IPage {
  step: STEPS;
  heading: string;
  buttonText: string;
  description?: string;
}

export interface IExercisePlan {
  steps: IPage[];
}